// extracted by mini-css-extract-plugin
export default {"component":"oIlpx","hidden":"s1Vuv","fixZindex":"zv1xy","decreased":"oB5HR","size":"WDvlg","available":"AVnUO","increased":"ectXs"};